import { provideHttpClient, withFetch } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideTranslateService, TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ClipboardModule } from 'ngx-clipboard';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { ModalModule } from 'ngx-bootstrap/modal';
import { ToastrModule } from 'ngx-toastr';
import { NotifLibraryModule } from 'notif-library';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BannerComponent } from './components/banner/banner.component';
import { FaqComponent } from './components/faq/faq.component';
import { FeatureComponent } from './components/feature/feature.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { HowToBuyComponent } from './components/how-to-buy/how-to-buy.component';
import { LanguageComponent } from './components/language/language.component';
import { RoundAndUserDetails } from './components/round-and-user-details/round-user-details.component';
import { ScrollerComponent } from './components/scroller/scroller.component';
import { SwapComponentV2 } from './components/swap/swap.component';
import { WidgetV2 } from './components/widget/widget.component';
import { BestwalletComponent } from './modals/bestwallet/bestwallet.component';
import { BuyETHWertComponent } from './modals/eth-buy-wert/buy-eth-wert.component';
import { NoWalletComponent } from './modals/no-wallet/no-wallet.component';
import { ReferComponent } from './modals/refer/refer.component';
import { WertComponent } from './modals/wert/wert.component';
import { SharedModule } from './shared/shared.module';
import { StakingComponent } from './components/staking/staking.component';
import { ClaimComponent } from './components/claim/claim.component';
import { RoadmapComponent } from './components/roadmap/roadmap.component';
import { TokenomicsComponent } from './components/tokenomics/tokenomics.component';
import { AboutComponent } from './components/about/about.component';

@NgModule({
  declarations: [
    AppComponent,
    BannerComponent,
    SwapComponentV2,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    LanguageComponent,
    NoWalletComponent,
    ClaimComponent,
    ReferComponent,
    WertComponent,
    ScrollerComponent,
    StakingComponent,
    FeatureComponent,
    FaqComponent,
    BestwalletComponent,
    RoundAndUserDetails, // This component is used to show the Round timer, User purchased details, Round title etc
    // This widget is uses the old Buy flow. Uses ETH, USDT and Card Tabs,
    WidgetV2, // This widget uses new buy flow. Buy with Card and Buy with Crypto,
    BuyETHWertComponent,
    HowToBuyComponent,
    RoadmapComponent,
    TokenomicsComponent,
    AboutComponent,
  ],
  imports: [
    // Angular Core
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,

    // Third-party (NGX & others) sorted alphabetically
    AccordionModule,
    AngularSvgIconModule.forRoot(),
    BsDropdownModule.forRoot(),
    CarouselModule,
    ClipboardModule,
    ModalModule.forRoot(),
    NgxChartsModule,
    NotifLibraryModule,
    PopoverModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 4000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
      disableTimeOut: false,
      progressBar: true,
      progressAnimation: 'decreasing',
      maxOpened: 1,
    }),
    TranslateDirective,
    TranslatePipe,

    // App Modules (Routing must be last if it has wildcard routes)
    SharedModule,
    AppRoutingModule,
  ],
  providers: [provideHttpClient(withFetch()), provideTranslateService(), provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }), provideClientHydration()],
  bootstrap: [AppComponent],
})
export class AppModule {}
